import Vue from 'vue'
const persistInterval = 24*60*60*1000; // 1 day
const accountPersistent = store => {
    store.subscribe( ( mutation, state ) => {
        if('auth/setUser' === mutation.type) {
            if(mutation.payload) {
                let record = { data:  mutation.payload.data, ts: ((mutation.payload.ts)?mutation.payload.ts:(new Date().getTime() + persistInterval))};
                try {
                    //add for blocking developer tool editing on browser
                    let encrypted = Vue.CryptoJS.AES.encrypt(JSON.stringify(record), process.env.VUE_APP_CP_SEC).toString();
                    localStorage.setItem( 'check-user', encrypted );
                } catch(e) {}
            } else {
                localStorage.removeItem( 'check-user');
                location.href= '/login'
            }
        }

        if( 'auth/initUser' === mutation.type) {
            let storage = false;
            try {
                storage = localStorage.getItem( 'check-user' ) || false;

                if( storage ) {
                    //add for blocking developer tool editing on browser
                    let decrypted = Vue.CryptoJS.AES.decrypt(storage, process.env.VUE_APP_CP_SEC);
                    let user = null
                    try {
                         user = decrypted.toString(Vue.CryptoJS.enc.Utf8)
                    } catch(e) {
                        localStorage.clear()
                        location.href= '/login'
                    }
                    storage = JSON.parse( user );
                } else {
                    if(location.pathname !== '/login') {
                        location.href = '/login'
                    }
                }
            } catch(e) {}

            if(storage) {

                if(new Date().getTime() > storage.ts) {
                    store.commit( 'auth/setUser', null );
                } else {
                    store.commit( 'auth/setUser', storage );
                }
            }
        }

    });
}

export default accountPersistent;
